export const FREE_TRIAL_LICENSES = 5;
